module.exports = __webpack_public_path__ + "img/95_justin.8d91a98c.jpg";